import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectBlob } from '../../../utils/select-blob';
import { withJwt } from '../../../utils/with-jwt';
import { smsNotificationServiceEnvironment } from '../sms-notification-service-environment';

export function postQrCode(
  this: unknown,
  params: { numberOfPixels: number; url: string }
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(smsNotificationServiceEnvironment.resolve(this).qrCodeUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(params),
      })
    )
  ).pipe(selectBlob());
}
